import { Chip, hexToRgb, Theme } from '@mui/material';
import styled from 'styled-components';

export type ColorType = 'primary' | 'error' | 'grey' | 'success' | 'warning' | 'primaryDark' | undefined;
const getChipColor = (color: ColorType, theme: Theme) => {
  if (theme.palette.mode === 'dark') {
    switch (color) {
      case 'primaryDark':
        return {
          backgroundColor: theme.palette.base.primary,
          color: theme.palette.base.foreground,
        };
      case 'primary':
        return {
          backgroundColor: hexToRgb(`${theme.palette[color][50]}`),
          color: hexToRgb(`${theme.palette[color][700]}`),
        };
      case 'error':
        return {
          backgroundColor: hexToRgb(`${theme.palette[color][50]}`),
          color: hexToRgb(`${theme.palette[color][700]}`),
        };

      case 'warning':
        return {
          backgroundColor: hexToRgb(`${theme.palette[color][50]}`),
          color: hexToRgb(`${theme.palette[color][600]}`),
        };

      case 'success':
        return {
          backgroundColor: hexToRgb(`${theme.palette[color][50]}`),
          color: hexToRgb(`${theme.palette[color][500]}`),
        };

      case 'grey':
        return {
          backgroundColor: hexToRgb(`${theme.palette[color][100]}80`),
          color: hexToRgb(`${theme.palette[color][500]}`),
        };
      default:
        return {
          backgroundColor: hexToRgb(`${theme.palette[color || 'primary'][100]}80`),
          color: hexToRgb(`${theme.palette[color || 'primary'][700]}`),
        };
    }
  } else {
    if (color === 'primaryDark') {
      return {
        backgroundColor: theme.palette.base.primary,
        color: 'white',
      };
    }
    return {
      backgroundColor: hexToRgb(`${theme.palette[color || 'primary'][50]}`),
      color: hexToRgb(`${theme.palette[color || 'primary'][700]}`),
    };
  }
};

type ChipStyledType = {
  chipstyle?: ColorType;
};
export const ChipStyled = styled(Chip)<ChipStyledType>(({ chipstyle, theme }) => ({
  backgroundColor: getChipColor(chipstyle as ColorType, theme).backgroundColor,
  color: getChipColor(chipstyle as ColorType, theme).color,
  fontWeight: 500,
  maxWidth: '450px',
  svg: {
    stroke: 'transparent',
    path: {
      stroke: theme.palette.grey[800],
    },
    rect: {
      fill: theme.palette.grey[300],
    },
  },
}));
